import { Component, OnInit, Inject, PLATFORM_ID } from "@angular/core";
import { UserService } from "../../../services/user.service";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { LoaderModalService } from "../../../services/loader.service";
import { CartlengthService } from "../../../services/cartlength.service";
import { CatDataUpdateServiceService } from "src/app/services/cat-data-update-service.service";
import { BehaviorService } from "src/app/services/behaviour.service";
import { CommonService } from "src/app/services/common.service";
import { Store } from "@ngrx/store";
import { AppState } from "state/app.state";
import { COMPOUND_LIST } from "src/app/shared/compound-list.constant";
import { isPlatformBrowser } from '@angular/common';
import SwiperCore, { Navigation, Scrollbar, Virtual, Thumbs, Controller } from "swiper";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  infoContent: any = [];
  deliveryAreas: any = [];
  ourSpecialityContent: any = [];
  homeCategory: any = [];
  aboutUs: any;
  aboutUsImage: any = [];
  index0Productarray = [];
  index1Productarray = [];
  index2Productarray = [];
  index3Productarray = [];
  index4Productarray = [];
  index5Productarray = [];
  mySlidesPerGroup: any;
  compoundList = COMPOUND_LIST;

  auth: any;
  defaultUrl = "assets/images/defaultimg.jpeg";
  banner$: Observable<any>;
  storeId: any;
  hasMatch = false;
  loader1: boolean = true;
  loader2: boolean = true;
  loader3: boolean = true;
  loader4: boolean = true;
  loader5: boolean = true;
  loader6: boolean = true;

  bannerArray = [];
  simmerBanner: boolean = false;
  isShown: boolean = false;
  storeMobile = "0000000000";
  userId: string;
  orderType: string;
  qtyValue = 1;
  selectedStoreId: any;
  categoryName: any;
  showVariance: boolean;
  errorMsg: any;

  showLatstProduct;
  tagList2;
  varqtyvalue: number = 0;
  style;
  hovered;
  SPECIESLIST;

  brandArray1 = [];
  brandArray2 = [];
  brandArray3 = [];
  isSuccess: boolean;

  CartBarLimit;
  CartBarLimitFlower;
  qty;
  letNewArray: Array<any> = [];
  imageDetails;
  promoData: any
  VARID;
  PREVIOUSVARID;
  productArrays: any = [];
  
 isBrowser: boolean;

  constructor(
    private userSrv: UserService,
    private router: Router,
    private ls: LoaderModalService,
    private _bs: BehaviorService,
    private commonService: CommonService,
    private cartLengthService: CartlengthService,
    private cartdataupdateService: CatDataUpdateServiceService,
    private storeState: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
     this.commonService.getSeoContent("home").subscribe((res) => {
          this.commonService.updateMetaKeywords(res?.title, res?.keywords, res?.description);
    });


    this.isBrowser = isPlatformBrowser(platformId);
    this.storeState.select("Store").subscribe((res: any) => {
      if (res?.currentActivePromo != null) {
        this.promoData = res?.currentActivePromo;
      }
    });

    if (this.isBrowser) {
      SwiperCore.use([Navigation, Scrollbar, Virtual, Thumbs, Controller]);
      let age = localStorage.getItem("ageVerify");
      let StoreId = localStorage.getItem("localStoreId");
      if (age == undefined) {
        this.router.navigateByUrl("verify/age");
        return;
      }

      if (StoreId == undefined || StoreId == null) {
        this.router.navigateByUrl("verify/age");
        return;
      }
      this.selectedStoreId = localStorage.getItem("localStoreId");
      this.getResigonList();
    }
  }

  ngOnInit(): void {
    this.getHomeContant();
    this.getHomePageCategory();
    
    if (this.isBrowser) {
      let covaid = localStorage.getItem("covaUserId");
      this.CartBarLimitFlower = localStorage.getItem("CartBarLimitFlower");
      if (covaid) {
        this.getUserData(covaid);
      }

      if (localStorage.getItem("addressStatus") === undefined || localStorage.getItem("addressStatus") === null) {
        this.showModal('#selectOrderStatusPopup');
      } else {
        this.selectedStoreId = localStorage.getItem("localStoreId");
        if (!this.selectedStoreId) {
          localStorage.clear();
          sessionStorage.clear();
        }
        this.showLatstProduct = false;
        this.showVariance = false;
       
        this.userId = localStorage.getItem("userId");
        this.commonService.getBannerForDesktop().subscribe((res) => {
          this.simmerBanner = true;
          res?.map((x, i) => {
            if (i === 0) {
              if (x?.desktopBanner) {
                this.bannerArray.push({
                  desktopBanner: x?.desktopBanner,
                  mobileBanner: x?.mobileBanner,
                  title: x?.title,
                  active: "active",
                  category: x?.category,
                  product: x?.product,
                  store: x?.store,
                  subCategory: x?.subCategory,
                  isHyperlink: x?.isHyperlink,
                  hyperlinkType: x?.hyperlinkType,
                });
              }
            } else {
              if (x?.desktopBanner) {
                this.bannerArray.push({
                  desktopBanner: x?.desktopBanner,
                  mobileBanner: x?.mobileBanner,
                  title: x?.title,
                  active: "",
                  category: x?.category,
                  product: x?.product,
                  store: x?.store,
                  subCategory: x?.subCategory,
                  isHyperlink: x?.isHyperlink,
                  hyperlinkType: x?.hyperlinkType,
                });
              }
            }
          });
        });
        this.index0Product();
        this.index1Product();
        this.index2Product();
        this.index3Product();
        this.index4Product();
        this.index5Product();
        this.userSrv.getAuth().subscribe((res) => {
          if (res) {
            this.auth = res;
          }
        });

        this.commonService.changeMessage(localStorage.getItem("userName"));
      }

      this.getHeaderCategory();
      this.calculateMarginTop();
    }
  }

  private showModal(selector: string): void {
    if (this.isBrowser && typeof window !== 'undefined' && window['$']) {
      window['$'](selector).modal('show');
    }
  }

  private hideModal(selector: string): void {
    if (this.isBrowser && typeof window !== 'undefined' && window['$']) {
      window['$'](selector).modal('hide');
    }
  }

  movileView() {
    if (this.isBrowser && window.innerWidth <= 768) {
      return 2;
    } else {
      return 4;
    }
  }

  thcType(type) {
    if (type == 0 || type == null || type == undefined) {
      return "%";
    } else {
      return type;
    }
  }

  checkZero(value: any) {
    if (value == 0 || value == null || value == undefined) {
      return false;
    } else {
      return true;
    }
  }

  getColor(type) {
    let style: any;
    if (this.isBrowser) {
      let siteDada = JSON.parse(localStorage.getItem("siteData"));
      if (siteDada?.viewMoreButtonColor) {
        style = { color: siteDada?.viewMoreButtonColor };
      } else {
        style = { color: "#000" };
      }
    } else {
      style = { color: "#000" };
    }
    return style;
  }

  redirectBanner(item) {
    if (item?.isHyperlink && item?.hyperlinkType == "PRODUCT" && item?.product && item?.product?.slug) {
      this.router.navigateByUrl(`product-details/${item?.product?.slug}`);
    }
    if (item?.isHyperlink && item?.hyperlinkType == "SUBCATEGORY" && item?.subCategory && item?.subCategory?.slug) {
      this.router.navigateByUrl(`shop/subProduct/${item?.category?.slug}_${item?.subCategory?.slug}`);
    }
    if (item?.isHyperlink && item?.hyperlinkType == "CATEGORY" && item?.category && item?.category) {
      if (item?.category?.categoryName == "New Arrivals") {
        this.router.navigateByUrl(`shop/NewArrivals`);
      } else if (item?.category?.categoryName == "Deals") {
        this.router.navigateByUrl(`shop/deals`);
      } else if (item?.category?.categoryName == "Staff Pick") {
        this.router.navigateByUrl(`shop/staff-pick`);
      } else {
        this.router.navigateByUrl(`shop/${item?.category?.categoryName}_${item?.category?.slug}`);
      }
    }
  }

  getCompoundValue(compoundKey: string, product: any): any {
    return product?.[compoundKey];
  }

  getHomeContant() {
    this.commonService.getHOmeContent().subscribe((res: any) => {
      if (res["meta"]["status"]) {
        this.isSuccess = true;
        this.ourSpecialityContent = res["data"]["ourSpecialityContent"];
        this.infoContent = res["data"]["infoContent"];
        this.aboutUs = res["data"]["aboutUs"];
        this.aboutUsImage = res["data"]["aboutUs"]["images"];
        this.brandArray1 = res["data"]["brand"]?.splice(0, 4);
        this.brandArray2 = res["data"]["brand"]?.splice(0, 4);
        this.brandArray3 = res["data"]["brand"]?.splice(0, 4);
      } else {
        this.isSuccess = false;
      }
    });
  }

  getHomePageCategory() {
    this.commonService.getHomeCategories().subscribe((res) => {
      if (res["meta"]["status"]) {
        this.homeCategory = res["data"];
      }
    });
  }

  getUserData(userId: any) {
    this.commonService.getUserProfile(userId).subscribe((res: any) => {
      if (res['meta']['status']) {
        if (this.isBrowser) {
          localStorage.setItem("userDetails", JSON.stringify(res.data));
        }
      }
    });
  }

  getBackGroundColor(tag) {
    if (tag) {
      return tag.tagColor;
    } else {
      return "#FFFFFF";
    }
  }

  HeaderCategory: any = [];
  getHeaderCategory() {
    this.commonService.getCategoryList().subscribe((res: any) => {
      if (res["meta"]["status"]) {
        this.HeaderCategory = res.data;
      }
    });
  }

  calculateMarginTop() {
    if (this.HeaderCategory.length > 23) {
      return "224";
    } else if (this.HeaderCategory.length > 15) {
      return "178";
    } else {
      return "120";
    }
  }

  index0Product() {
    this.index0Productarray = [];
    this.loader1 = true;
    this.commonService.index0Product(this.selectedStoreId).subscribe((res) => {
      this.index0Productarray = res["data"];
      this.productArrays[0] = this.index0Productarray;
      this.loader1 = false;
      this.showLatstProduct = true;
    });
  }

  index1Product() {
    this.index1Productarray = [];
    this.loader2 = true;
    this.commonService.index1Product(this.selectedStoreId).subscribe((res) => {
      this.index1Productarray = res["data"];
      this.productArrays[1] = this.index1Productarray;
      this.loader2 = false;
    });
  }

  index2Product() {
    this.index2Productarray = [];
    this.loader3 = true;
    this.commonService.index2Product(this.selectedStoreId).subscribe((res) => {
      this.index2Productarray = res["data"];
      this.productArrays[2] = this.index2Productarray;
      this.loader3 = false;
    });
  }

  index3Product() {
    this.index3Productarray = [];
    this.loader4 = true;
    this.commonService.index3Product(this.selectedStoreId).subscribe((res) => {
      this.index3Productarray = res["data"];
      this.productArrays[3] = this.index3Productarray;
      this.loader4 = false;
    });
  }

  index4Product() {
    this.index4Productarray = [];
    this.loader5 = true;
    this.commonService.index4Product(this.selectedStoreId).subscribe((res) => {
      this.index4Productarray = res["data"];
      this.productArrays[4] = this.index4Productarray;
      this.loader5 = false;
    });
  }

  index5Product() {
    this.index5Productarray = [];
    this.loader6 = true;
    this.commonService.index5Product(this.selectedStoreId).subscribe((res) => {
      this.index5Productarray = res["data"];
      this.productArrays[5] = this.index5Productarray;
      this.loader6 = false;
    });
  }

  redirectToDetailPage(slug: string) {
    this.router.navigateByUrl(`/product-details/${slug}`);
  }

  getImageSize3(array) {
    if (array.length) {
      return array[0]["Uri"];
    } else {
      return this.defaultUrl;
    }
  }

  getBannerImg(bannerImg) {
    return bannerImg;
  }

  getOrderType() {
    if (this.isBrowser && localStorage.getItem("isPickUpOrder") === "true") {
      this.orderType = "Pickup";
      return "Pickup";
    } else {
      this.orderType = "Delivery";
      return "Delivery";
    }
  }

  actualId;

  showDiv1(item) {
    this.varqtyvalue = 0;
    this.actualId = item;
    this.isShown = false;
  }

  varianceArray;

  openModal(val) {
    if (val == 1) {
      this.hideModal('#worry_address_searchbar');
      this.hideModal('#SearchLocation');
      this.showModal('#SearchLocation1');
    }
    if (val == 0) {
      this.hideModal('#worry_address_searchbar');
      this.hideModal('#SearchLocation1'); //delivery
      this.showModal('#SearchLocation'); //map
    }
  }

  closePop() {
    this.hideModal('#worry_address_searchbar');
  }

  addSelectedVariance(productDetails) {
    if (!this.auth) {
      if (!this.isBrowser) return;
      
      let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));

      let array = currentcartProd?.product.filter((product) => product?.productId == productDetails?.CatalogItemId);
      if (array?.length == 0) {
        this.addToCart(productDetails);
      } else {
        array?.forEach((itm: any, i) => {
          if (itm?.productId == productDetails?.CatalogItemId) {
            if (itm?.quantity < productDetails?.Quantity) {
              this.addToCart(productDetails);
            } else {
              this.ls.startLoader("", "");
              this.ls.changeStateandStopLoader("error", `Maximum quantity of this product is ${productDetails?.Quantity}`, 2000);
            }
          }
        });
        if (currentcartProd == undefined) {
          this.addToCart(productDetails);
        }
      }
    } else {
      this.addToCart(productDetails);
    }
  }

  offlineWeightCheck(productDetails, value, list) {
    if (!this.isBrowser) return;
    
    let flowerLimit: any = localStorage.getItem("CartBarLimitFlower");
    let otherLimit: any = localStorage.getItem("CartBarLimit");
    let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
    if (currentcartProd && currentcartProd["product"] && currentcartProd["product"]?.length) {
      if (this.CartBarLimitFlower > 0) {
        if (this._bs.fetchCategoryId(list?.category) == 2543 && this._bs.fetchCategoryId(list?.category) != 2542) {
          let flowerProducts: any = currentcartProd["product"]?.filter((itm) => itm?.categoryId == 2543);
          let floweWeight: any = 0;
          flowerProducts?.forEach((element) => {
            floweWeight += element?.equivalentToVal * element?.quantity;
          });
          if (Number(floweWeight) + Number(productDetails?.productDetails?.EquivalentToVal) > flowerLimit) {
            this.showModal('#cartLimitModalFlower');
            setTimeout(() => {
              this.hideModal('#cartLimitModalFlower');
            }, 1500);
            return;
          } else {
            this.addOfflineProductInCart(productDetails, value, list);
          }
        }

        if (this._bs.fetchCategoryId(list?.category) != 2543 && this._bs.fetchCategoryId(list?.category) != 2542) {
          let otherProducts: any = currentcartProd["product"]?.filter((itm) => itm?.categoryId != 2543);
          let otherWeight: any = 0;
          otherProducts?.forEach((element) => {
            otherWeight += element?.equivalentToVal * element?.quantity;
          });
          if (Number(otherWeight) + Number(productDetails?.productDetails?.EquivalentToVal) > otherLimit) {
            this.showModal('#cartLimitModal');
            setTimeout(() => {
              this.hideModal('#cartLimitModal');
            }, 1500);
            return;
          } else {
            this.addOfflineProductInCart(productDetails, value, list);
          }
        }
      } else {
        let otherWeight: any = 0;
        currentcartProd["product"]?.forEach((element) => {
          otherWeight += element?.equivalentToVal * element?.quantity;
        });
        if (Number(otherWeight) + Number(productDetails?.productDetails?.EquivalentToVal) > otherLimit) {
          this.showModal('#cartLimitModal');
          setTimeout(() => {
            this.hideModal('#cartLimitModal');
          }, 1500);
          return;
        } else {
          this.addOfflineProductInCart(productDetails, value, list);
        }
      }
    } else {
      this.addOfflineProductInCart(productDetails, value, list);
    }
  }

  addToCart(productDetails) {
    if (!this.isBrowser) return;
    
    this.CartBarLimit = Number(localStorage.getItem("CartBarLimit"));
    this.CartBarLimitFlower = Number(localStorage.getItem("CartBarLimitFlower"));
    const addressStatus = localStorage.getItem("addressStatus");
    if (addressStatus === null || addressStatus === "false") {
      this.showModal('#SearchLocation');
    } else if (!this.auth) {
      this.offlineWeightCheck(productDetails, false, productDetails);
    } else {
      let limit = localStorage.getItem("cartLimit");
      let limitFlower = localStorage.getItem("cartLimitFlower");
      let obj = {
        inventoryId: productDetails.CatalogItemId,
        selectQuantity: this.qtyValue,
        storeId: Number(localStorage.getItem("localStoreId")),
        orderType: this.getOrderType(),
        productId: productDetails.CatalogItemId,
        productslug: productDetails?.productslug,
        otherWtSum: limit ? limit : 0,
        flowerWtSum: limitFlower ? limitFlower : 0,
        qtyIncrease: true,
        recommended: "NO",
        categoryId: this._bs.fetchCategoryId(productDetails?.category),
      };
      this.ls.startLoader("", "");

      this.commonService.addProductInCartnew(obj).subscribe((res) => {
        if (res["meta"]["status"]) {
          let cartLength = res["data"]["addtoCart"] ? res["data"]["addtoCart"].length : 0;
          this.cartdataupdateService.cartDataUpdateFunction(res);
          this.commonService.emittedCartValue.next(true);

          this.cartLengthService.cartLengthUpdateFunction(cartLength);
          this.ls.changeStateandStopLoader("success", "Added to Cart", 1000);
          // this._dataLayerService.addToCartGTM(res["data"]["addtoCart"]);
        } else {
          this.errorMsg = res["meta"]["msg"];
          if (this.errorMsg === "Store must be unique ! Please try again with same store") {
            this.showModal('#exampleModal');
            this.ls.stopLoader();
          } else if (this.errorMsg == `You can not add products more than ${localStorage.getItem("CartBarLimit")}g`) {
            this.ls.stopLoader();
          } else if (this.errorMsg == `You can not add products more than ${localStorage.getItem("CartBarLimitFlower")}g`) {
            this.ls.stopLoader();
          } else {
            this.ls.changeStateandStopLoader("error", res["meta"]["msg"], 3000);
          }
        }
      });
    }
  }

  addOfflineProductInCart(productDetails, boolean?, list?) {
    if (!this.isBrowser) return;
    
    this.ls.startLoader("", "");
    let image;
    let productName = "";
    this.imageDetails = productDetails["productDetails"].Assets;
    let currentcartWeight = 0;
    let currentProductWeight: any;
    let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
    if (currentcartProd && currentcartProd["product"]) {
      currentProductWeight = productDetails?.productDetails?.EquivalentToVal ? productDetails?.productDetails?.EquivalentToVal : 0;
      currentcartProd["product"].forEach((cartPd) => {
        currentcartWeight = currentcartWeight + cartPd.weight * cartPd.quantity;
      });
    }
    let totalWeight = Number(currentcartWeight) + Number(currentProductWeight);
    this.CartBarLimit = localStorage.getItem("CartBarLimit");
    if (totalWeight > this.CartBarLimit) {
      this.ls.stopLoader();
      this.showModal('#cartLimitModal');
      return;
    }

    if (this.imageDetails !== undefined && this.imageDetails?.length > 0) {
      if (this.imageDetails[0]?.Uri !== null && this.imageDetails[0]?.Uri !== "") {
        image = this.imageDetails[0]?.Uri;
      } else {
        image = this.defaultUrl;
      }
    } else {
      image = this.defaultUrl;
    }
    if (list != undefined && list !== null) {
      this.imageDetails = list["productDetails"].Assets;
      productName = productDetails["productDetails"]?.ProductName;
      if (this.imageDetails !== undefined && this.imageDetails?.length > 0) {
        if (this.imageDetails[0]?.Uri !== null && this.imageDetails[0]?.Uri !== "") {
          image = this.imageDetails[0]?.Uri;
        } else {
          image = this.defaultUrl;
        }
      } else {
        image = this.defaultUrl;
      }
    } else {
      productName = productDetails["productDetails"]?.ProductName;
    }
    if (boolean) {
      this.qty = this.varqtyvalue++;
    }
    var hasMatch = false;
    let array = JSON.parse(localStorage.getItem("cartProduct"));
    this.letNewArray.push(array);
    let productArray = [];
    let cartProductArrayWithStore;
    //---------------------- condition store change   cart become null
    if (localStorage.getItem("cartProduct") === null || array?.length === 0) {
      this.varqtyvalue = 1; //first time variance add

      cartProductArrayWithStore = {
        storeId: localStorage.getItem("localStoreId"),
      };

      productArray.push({
        productId: productDetails?.CatalogItemId,
        productType: "simple",
        myPrice: productDetails?.myPrice,
        inventoryType: productDetails?.inventoryType,
        storeId: localStorage.getItem("localStoreId"),
        quantity: 1,
        productslug: productDetails?.productslug,
        weight: productDetails?.productDetails ? productDetails?.productDetails?.EquivalentToVal : 0,
        productName: productName,
        actualQuantity: productDetails?.Quantity,
        productImg: image ? image : this.defaultUrl,
        price: productDetails?.price,
        buyPrice: productDetails?.Msrp,
        purchaseStatus: "purchase",
        productDisplayId: productDetails?.CatalogItemId,
        equivalentToVal: productDetails?.productDetails ? productDetails?.productDetails?.EquivalentToVal : 0,
        require: "Require",
        selectQuantity: 1,
        productTitle: productName,
        categoryId: this._bs.fetchCategoryId(list?.category),
        withoutDiscountPrice: productDetails?.price,
      });

      this.letNewArray = productArray;

      cartProductArrayWithStore["product"] = productArray;
      localStorage.setItem("cartProduct", JSON.stringify(cartProductArrayWithStore));
      this.ls.changeStateandStopLoader("success", "Added to Cart", 2000);
      this.commonService.emittedCartValue.next(true);
      this.commonService.go_invokeCartResetFunction_forguest(); // rest guest cart  screen to to 1
    } else {
      let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
      let currentcartWeight = 0;
      currentcartProd["product"].forEach((cartPd) => {
        currentcartWeight = currentcartWeight + cartPd?.weight * cartPd?.quantity;
      });
      this.CartBarLimit = localStorage.getItem("CartBarLimit");

      let productArrayData = JSON.parse(localStorage.getItem("cartProduct"));
      productArray = productArrayData["product"];
      if (productArrayData["storeId"] === localStorage.getItem("localStoreId")) {
        for (var i = 0; i < productArray.length; i++) {
          if (productArray[i].productId === productDetails.CatalogItemId) {
            this.varqtyvalue = 1; //first time variance add
            let removedata = productArray.splice(i, 1);
            productArray.push({
              productId: productDetails?.CatalogItemId,
              productType: "simple",
              myPrice: productDetails?.myPrice,
              productslug: productDetails?.productslug,
              actualQuantity: productDetails?.Quantity,
              inventoryType: productDetails.inventoryType,
              storeId: localStorage.getItem("localStoreId"),
              quantity: Number(removedata[0]["quantity"]) + 1,
              weight: productDetails?.productDetails ? productDetails?.productDetails?.EquivalentToVal : 0,
              productName: productName,
              productImg: image,
              price: productDetails.price,
              buyPrice: productDetails.Msrp,
              purchaseStatus: "purchase",
              productDisplayId: productDetails.CatalogItemId,
              equivalentToVal: productDetails?.productDetails ? productDetails?.productDetails?.EquivalentToVal : 0,
              require: "Require",
              selectQuantity: Number(removedata[0]["quantity"]) + 1,
              productTitle: productName,
              categoryId: this._bs.fetchCategoryId(list?.category),
              withoutDiscountPrice: productDetails.price,
            });

            localStorage.setItem("cartProduct", JSON.stringify(productArrayData));
            this.ls.changeStateandStopLoader("success", "Added to Cart", 3000);
            this.commonService.emittedCartValue.next(true);
            this.commonService.go_invokeCartResetFunction_forguest(); // rest guest cart  screen to to 1
            hasMatch = true;
            break;
          }
        }
      } else {
        this.ls.changeStateandStopLoader("error", "Clear cart first then add product", 3000);
      }

      if (!hasMatch) {
        this.varqtyvalue = 1; //first time variance add

        productArray.push({
          productId: productDetails.CatalogItemId,

          productType: "simple",
          myPrice: productDetails?.myPrice,
          inventoryType: productDetails.inventoryType,
          storeId: localStorage.getItem("localStoreId"),
          quantity: this.qtyValue,
          weight: productDetails.productDetails.EquivalentToVal ? productDetails.productDetails.EquivalentToVal : 0,
          productName: productName,
          productslug: productDetails?.productslug,
          actualQuantity: productDetails?.Quantity,
          productImg: image,
          price: productDetails.price,
          buyPrice: productDetails.Msrp,
          purchaseStatus: "purchase",
          productDisplayId: productDetails.CatalogItemId,
          equivalentToVal: productDetails.productDetails.EquivalentToVal ? productDetails.productDetails.EquivalentToVal : 0,
          require: "Require",
          selectQuantity: this.qtyValue,
          productTitle: productName,
          categoryId: this._bs.fetchCategoryId(list?.category),
          withoutDiscountPrice: productDetails.price,
        });

        let cartProductArrayWithStore = {
          storeId: localStorage.getItem("localStoreId"),
          product: productArray,
        };

        localStorage.setItem("cartProduct", JSON.stringify(cartProductArrayWithStore));
        this.ls.changeStateandStopLoader("success", "Added to Cart", 2000);
        this.commonService.emittedCartValue.next(true);
        this.commonService.go_invokeCartResetFunction_forguest(); // rest guest cart  screen to to 1
      }
    }
    // this._dataLayerService.addToCartGTMGuest(productArray);
    this.letNewArray = productArray;
    this.increaseValues(this.letNewArray, productDetails.CatalogItemId, this.letNewArray[0].quantity);
    this.commonService.updateCartProduct(productArray.length);
  }

  routeForViewMoreButtons(name) {
    if (name == "Shop") {
      this.router.navigateByUrl(`shop/all`);
    } else if (name == "Brands") {
      this.router.navigateByUrl(`brand/list`);
    } else if (name == "Deals") {
      this.router.navigateByUrl(`shop/deals`);
    } else if (name == "Contact Us") {
      this.router.navigateByUrl(`contact-us`);
    } else if (name == "Flower") {
      this.router.navigateByUrl(`shop/Flower_flower`);
    } else if (name == "New Arrivals") {
      this.router.navigateByUrl(`shop/NewArrivals`);
    } else if (name == "CBD") {
      this.router.navigateByUrl(`shop/CBD_cbd`);
    } else if (name == "Accessories") {
      this.router.navigateByUrl(`shop/Accessories_accessories`);
    } else if (name == "Edibles") {
      this.router.navigateByUrl(`shop/Edibles_edibles`);
    } else if (name == "Concentrates") {
      this.router.navigateByUrl(`shop/Concentrates_concentrates`);
    } else if (name == "Vapourizers") {
      this.router.navigateByUrl(`shop/Vapourizers_vapourizers`);
    } else if (name == "Vapes") {
      this.router.navigateByUrl(`shop/Vapes_vaporizers`);
    } else if (name == "Pre Rolls") {
      this.router.navigateByUrl(`shop/Pre roll_pre-rolls`);
    } else if (name == "Pre Rolls") {
      this.router.navigateByUrl(`shop/Pre roll_pre-rolls`);
    }
  }

  // for clearing the varqtyvalue to 0 if we click diff div
  HandleVarinceAddToCartOrNot(data: any, index) {
    if (data?.finalqty < 1) {
      data["finalqty"] = 0;
    }

    if (!this.PREVIOUSVARID) {
      this.VARID = data._id;
      this.PREVIOUSVARID = data._id;
    } else {
      if (this.PREVIOUSVARID != data._id) {
        this.varqtyvalue = 0;
        this.VARID = data._id;
        this.PREVIOUSVARID = data._id;
      }
    }
  }

  checkThc(min, max) {
    if (min == 0 && max == 0) {
      return false;
    }
    if (min < max) {
      return true;
    } else if (min == max && max > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  brandRoute(id) {
    this.router.navigate([`brand/details`], { queryParams: { brandId: id } });
  }

  getBackGroundColorAccToSpecies(name) {
    return "#f8f8f8";
  }

  getFullName(item: any) {
    if (item != undefined && item != null) {
      return item?.split("")[0];
    }
  }

  //add var. or not
  increaseDecreaseOfflineProduct(productId, data, list) {
    if (data?.finalqty == undefined || data?.finalqty == 0) {
      return;
    }
    let images = "";
    if (data["productDetails"].HeroShotUri !== null) {
      images = data["productDetails"].HeroShotUri;
    } else {
      images = this.defaultUrl;
    }
    if (this.auth) {
      this.addToCartvar(data["productDetails"], false, images);
    } else {
      if (!this.isBrowser) return;
      
      let currentcProd = JSON.parse(localStorage.getItem("cartProduct"));
      let objIndex = currentcProd["product"].findIndex((obj) => obj?.productId == productId);
      currentcProd["product"][objIndex]["buyPrice"] = currentcProd["product"][objIndex]["buyPrice"];
      currentcProd["product"][objIndex]["actualQuantity"] = currentcProd["product"][objIndex]["actualQuantity"];
      currentcProd["product"][objIndex]["myPrice"] = currentcProd["product"][objIndex]["myPrice"];
      currentcProd["product"][objIndex]["price"] = currentcProd["product"][objIndex]["price"];
      currentcProd["product"][objIndex]["productDisplayId"] = currentcProd["product"][objIndex]["productDisplayId"];
      currentcProd["product"][objIndex]["productId"] = currentcProd["product"][objIndex]["productId"];
      currentcProd["product"][objIndex]["productImg"] = currentcProd["product"][objIndex]["productImg"];
      currentcProd["product"][objIndex]["productName"] = currentcProd["product"][objIndex]["productName"];
      currentcProd["product"][objIndex]["productType"] = currentcProd["product"][objIndex]["productType"];
      currentcProd["product"][objIndex]["productslug"] = currentcProd["product"][objIndex]["productslug"];
      currentcProd["product"][objIndex]["purchaseStatus"] = currentcProd["product"][objIndex]["purchaseStatus"];
      currentcProd["product"][objIndex]["quantity"] = currentcProd["product"][objIndex]["quantity"] - 1;
      currentcProd["product"][objIndex]["storeId"] = currentcProd["product"][objIndex]["storeId"];
      currentcProd["product"][objIndex]["weight"] = currentcProd["product"][objIndex]["weight"];
      currentcProd["product"][objIndex]["categoryId"] = this._bs.fetchCategoryId(list?.category);
      localStorage.setItem("cartProduct", JSON.stringify(currentcProd));
      this.commonService.go_invokeCartResetFunction_forguest(); // cart r=screen reset to 1

      this.increaseValues(currentcProd, productId, currentcProd[objIndex]?.quantity);
    }
  }


  increaseValues(array?, id?, qty?) {
    let changevarArr = this.varianceArray;
    if (this.auth) {
      for (let i = 0; i <= array?.length; i++) {
        changevarArr.map((e) => {
          if (array[i]?.inventoryId == e?.CatalogItemId) {
            e["finalqty"] = qty;
          }
        });
        this.varianceArray = changevarArr;
      }
    } else {
     if (this.isBrowser) {
       let currentcartProd = JSON.parse(localStorage.getItem("cartProduct"));
      let arrayodproducts = currentcartProd["product"];
      for (let i = 0; i <= arrayodproducts?.length; i++) {
        changevarArr?.map((e) => {
          if (arrayodproducts[i]?.productId == e?.CatalogItemId) {
            e["finalqty"] = arrayodproducts[i]?.quantity;
          }
        });
      }
     }
    }
    return this.varianceArray;
  }
  cartLength = 0;

  removeProductFromOfflineCart(productId, productDetails) {
   if (this.isBrowser) {
     if (!this.auth) {
      let offlineData = [];
      offlineData = JSON.parse(localStorage.getItem("cartProduct"));
      offlineData["product"].map((x, i) => {
        if (productDetails.productType === "simple") {
          if (x.productId === productId) {
            let data: any = offlineData["product"].filter((itm) => itm?.productId != productDetails?.CatalogItemId);
            let itm: any = {};
            itm["product"] = data;
            localStorage.setItem("cartProduct", JSON.stringify(itm));
            this.cartLength = itm["product"].length;
            if (!this.cartLength) {
              this.cartLengthService.cartLengthUpdateFunction(0);
              this.ngOnInit();
            } else {
              this.cartLengthService.cartLengthUpdateFunction(this.cartLength);
              this.ngOnInit();
            }
          }
        } else {
          if (x.productId === productDetails?.CatalogItemId) {
            let data: any = offlineData["product"].filter((itm) => itm?.productId != productDetails?.CatalogItemId);
            let itm: any = {};
            itm["product"] = data;

            localStorage.setItem("cartProduct", JSON.stringify(itm));
            this.cartLength = itm["product"]?.length;
            this.commonService.emittedCartValue.next(true);
            this.commonService.updateCartProduct(itm["product"]?.length);
          }
        }
      });
    } else {
      this.getonlinedata(productDetails);
    }

    let varArr = this.varianceArray;
    for (let i = 0; i <= varArr.length; i++) {
      varArr.map((e) => {
        if (productDetails.CatalogItemId == e.CatalogItemId) {
          e["finalqty"] = 0;
        }
      });
      this.varianceArray = varArr;
    }
   }
  }

  getonlinedata(productDetails) {
   if (this.isBrowser) {
     var isSwitchStatus = "false";
    var storeID = localStorage.getItem("localStoreId");

    isSwitchStatus = localStorage.getItem("isSwitch");
    this.ls.startLoader("", "");
    this.commonService.getUserCartProduct(isSwitchStatus, storeID).subscribe(
      (res: any) => {
        if (res["data"] && res["data"]["addtoCart"]) {
          this.varqtyvalue = 0
          res["data"]["addtoCart"];
          res["data"]["addtoCart"]?.forEach((element) => {
            if (element?.Id == productDetails?.CatalogItemId) {
              this.onlineremoveProduct(element?._id, "");
            }
          });
        }
      },
      (error) => {
        this.ls.changeStateandStopLoader("error", error.msg, 1000);
      }
    );
   }
  }

  reduceByPercentagePrice(value, percentage) {
    const reduction = (percentage / 100) * value;
    return (value - reduction)?.toFixed(2);
  }

  findOfferPre(item: any) {
    if (!this.promoData) return null; // No promo data available
    const { discountOnSubCategory, discountOnCategory } = this.promoData;

    // Priority 1: Check for Sub-Category-based promo if sub-category discounts exist    
    if (discountOnSubCategory?.length > 0) {
      if (item?.subCategory?.length) {
        const hasSubCategoryDiscount = item.subCategory.some(e =>
          discountOnSubCategory.includes(Number(e.subCategoryId))
        );
        if (hasSubCategoryDiscount) {
          return this.promoData; // 🎯 Promo applies based on sub-category
        }
      }
      return null; //No sub-category match, no promo even if category matches
    }
    //Priority 2: Fallback to Category-based promo if no sub-category discounts exist
    if (discountOnCategory?.length && item?.category?.length) {
      const hasCategoryDiscount = item.category.some(e =>
        discountOnCategory.includes(Number(e.categoryId))
      );

      if (hasCategoryDiscount) {
        return this.promoData; // 🎯 Promo applies based on category
      }
    }

    return null; //No applicable promo found
  }
  onlineremoveProduct(subProductId, productId) {
    let obj = {
      productSubId: subProductId,
      productId: productId,
    };
    this.ls.startLoader("", "");
    this.commonService.removeProductFromCart(obj).subscribe((res) => {
      if (res["meta"]["status"]) {
        this.commonService.updateCartProduct(0);
        this._bs.setCart("remove");
        this.ls.changeStateandStopLoader("success", "Remove from Cart", 1000);
        this.commonService.emittedCartValue.next(true);

        let userCartLength = res["data"]["addtoCart"] ? res["data"]["addtoCart"].length : 0;
        this.cartLengthService.cartLengthUpdateFunction(userCartLength);
      } else {
        this.ls.stopLoader();

        if (res["meta"]["msg"] == "No Product found in your cart.") {
          this.cartLengthService.cartLengthUpdateFunction(0);
          this.commonService.updateCartProduct(0);
        }
      }
    });
  }
  quantity: any = 0;
  controlledSwiper: any;
  setControlledSwiper(swiper) {
    this.controlledSwiper = swiper;
  }

  addToCartvar(productDetails, boolean, list?) {
   if (this.isBrowser) {
     if (!this.auth) {
      this.addOfflineProductInCart(productDetails, boolean, list);
    } else {
      this.quantity = this.quantity + 1;

      if (this.quantity > 1) {
        return;
      }
      //-------------After Login Perform--------------------------------------
      let limit = localStorage.getItem("cartLimit");
      if (Number(limit) > this.CartBarLimit) {
                  this.showModal('#cartLimitModal');    
                  }

      let obj = {};

      if (!boolean) {
        obj = {
          inventoryId: productDetails.CatalogItemId,
          selectQuantity: 1,
          storeId: Number(localStorage.getItem("localStoreId")),
          orderType: this.getOrderType(),
          productId: productDetails.CatalogItemId,
          wtSum: limit,
          qtyIncrease: false,
        };
      } else {
        this.ls.startLoader("", "");
        obj = {
          inventoryId: productDetails.CatalogItemId,
          selectQuantity: 1,
          storeId: Number(localStorage.getItem("localStoreId")),
          orderType: this.getOrderType(),
          productId: productDetails.CatalogItemId,
          wtSum: limit,
          qtyIncrease: true,
          recommended: "NO",
        };
      }
      this.commonService.addProductInCartnew(obj).subscribe((res) => {
        this.quantity = 0;
        this.ls.changeStateandStopLoader("success", "Added to Cart", 1000);

        if (res["meta"]["status"]) {
          let userCartLength = res["data"]["addtoCart"] ? res["data"]["addtoCart"].length : 0;
          this.cartLengthService.cartLengthUpdateFunction(userCartLength);
          this.cartdataupdateService.cartDataUpdateFunction(res);

          if (boolean) {
            this.varqtyvalue = this.varqtyvalue + 1;
          } else {
            this.varqtyvalue = this.varqtyvalue - 1;
          }
          this.ls.changeStateandStopLoader("success", "Added to Cart", 1000);
          this.increaseValues(res["data"]["addtoCart"], "", this.varqtyvalue);
        } else {
          this.errorMsg = res["meta"]["msg"];

          if (this.errorMsg === "Store must be unique ! Please try again with same store") {
           this.showModal('#exampleModal');    

          } else if (this.errorMsg == `You can not add products more than ${this.CartBarLimit}g`) {
              this.hideModal('#cartLimitModal');    
            this.ls.stopLoader();
          } else {
            this.ls.changeStateandStopLoader("error", res["meta"]["msg"], 3000);
          }
        }
      });
    }
   }
  }

  showVarianceList(array, catalogItemId, boolean) {
    this.actualId = catalogItemId;
    this.isShown = true; //collect varient data
    this.varianceArray = array;
    //
    this.varianceArray.map((e) => {
      e["finalqty"] = 0;
    });

    this.showVariance = true;
  }

  getBrandName(data) {
    let brandObj = data.productDetails.brand;
    let name = brandObj["brandName"] != "" ? brandObj["brandName"] : "BRAND NAME";
    return name;
  }


  routeToDelivery(item) {
    let url: any = `weed-delivery/${item?.regionName}`
    if (item?.status == 'ACTIVE') {
      // window.open(url, '_blank');
      this.router.navigateByUrl(url)
    }
  }

  getResigonList() {
    this.commonService.Get('/regioncontent/list?resPerPage=20&page=1').subscribe((res) => {
      if (res['meta']['status']) {
        this.deliveryAreas = res['data']?.reverse();
      }
    });
  }
}
